/** PURE_IMPORTS_START  PURE_IMPORTS_END */
"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
